module.exports = __webpack_public_path__ + "img/file_blue.13c1917f.svg";